import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';

import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

import ViewModel from './ViewModel';

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
});

class SnackbarMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.calculateMessage(props);
  }

  calculateMessage(props) {
    return {
      open: props.open,
      type: (props.type ? props.type : 'info'),
      message: (props.response ? (props.response.code === 'EDT_INTERNAL_ERROR' ? 'Une erreur interne s\'est produite' : props.response.message) : ''),
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.calculateMessage(nextProps));
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    ViewModel.sendEvent('snackbarMessage', {
      close: true,
    });
  };

  componentDidMount() {
    ViewModel.setIsLoading(false);
  }
  
  render() {
    const { classes } = this.props;

    return (
      <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.open}
          autoHideDuration={5000}
          onClose={this.handleClose}>
        <SnackbarContent
          message={this.state.message}
          className={classes[this.state.type]}
          action={[
            <IconButton
              key="close"
              aria-label="Fermer"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]} />
      </Snackbar>
    )
  }
}

window.openSnackbarMessage = (message, type) => {
  ViewModel.sendEvent('snackbarMessage', {
    response: {
      message,
    },
    type,
  });
};

SnackbarMessage.SnackTypes = {
  EDT_DELETE_SUCCESS: 'EDT_DELETE_SUCCESS',
  EDT_DELETE_ERROR: 'EDT_DELETE_ERROR',
}

SnackbarMessage.open = (response, type) => {
  ViewModel.sendEvent('snackbarMessage', {
    response,
    type,
  });
};

SnackbarMessage.success = (response) => {
  ViewModel.sendEvent('snackbarMessage', {
    response,
    type: 'success',
  });
};

SnackbarMessage.error = (error) => {
  let messageError = {};

  if (error.response && error.response.data.error) {
    messageError = error.response.data.error;
  } else if (error.request) {
    messageError = {
      code: 'EDT_NO_RESPONSE', 
      message: 'Aucune réponse n\'a été reçue, veuillez vérifier votre connexion à internet.'
    };
  } else {
    messageError = {
      code: 'EDT_CALL_ERROR', 
      message: 'Une erreur a eu lieu lors du traitement de votre demande.'
    }
  }
  ViewModel.sendEvent('snackbarMessage', {
    response: messageError,
    type: 'error',
  });
};

export default withStyles(styles)(SnackbarMessage);



// WEBPACK FOOTER //
// ./src/SnackbarMessage.js